"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const icons_material_1 = require("@mui/icons-material");
const Accordion = ({ className, collapsedByDefault = false, content, id, title }) => {
    const [expanded, setExpanded] = (0, react_1.useState)(!collapsedByDefault);
    // Header/Content IDs
    const headerId = `accordion__header--${id}`;
    const contentId = `accordion__content--${id}`;
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('accordion', expanded && 'accordion--expanded', className) },
        react_1.default.createElement("button", { "aria-controls": contentId, "aria-expanded": expanded, className: "accordion__header", id: headerId, onClick: () => setExpanded(!expanded) },
            react_1.default.createElement(icons_material_1.ChevronRightRounded, { className: "accordion__icon" }),
            title),
        react_1.default.createElement("div", { "aria-labelledby": headerId, className: "accordion__content", id: contentId }, content)));
};
exports.default = Accordion;
